export const VIEWPORT_MARGIN = 12;
export const POPOVER_GAP = 8;

const isVisible = (element) => {
  if (!element) return false;
  const styles = window.getComputedStyle(element);
  const rect = element.getBoundingClientRect();
  return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
};

const getBottomBoundary = (left, width) => {
  let boundary = window.innerHeight - VIEWPORT_MARGIN;
  const nav = document.querySelector('.nf-app-navigation');

  if (isVisible(nav)) boundary = Math.min(boundary, nav.getBoundingClientRect().top - VIEWPORT_MARGIN);

  document.querySelectorAll('.dashboard-v2-fab, .movements-page__fab').forEach((fab) => {
    if (!isVisible(fab)) return;
    const rect = fab.getBoundingClientRect();
    const overlapsHorizontally = left < rect.right + POPOVER_GAP && left + width > rect.left - POPOVER_GAP;
    if (overlapsHorizontally) boundary = Math.min(boundary, rect.top - VIEWPORT_MARGIN);
  });

  return Math.max(VIEWPORT_MARGIN, boundary);
};

export const measureAnchoredPopover = ({ anchor, panel, preferredWidth, minimumHeight = 44 }) => {
  if (!anchor || !panel) return null;

  const anchorRect = anchor.getBoundingClientRect();
  const width = Math.min(preferredWidth, window.innerWidth - VIEWPORT_MARGIN * 2);
  const left = Math.min(
    Math.max(VIEWPORT_MARGIN, anchorRect.right - width),
    window.innerWidth - width - VIEWPORT_MARGIN
  );
  const desiredHeight = panel.scrollHeight;
  const bottomBoundary = getBottomBoundary(left, width);
  const below = Math.max(0, bottomBoundary - anchorRect.bottom - POPOVER_GAP);
  const above = Math.max(0, anchorRect.top - VIEWPORT_MARGIN - POPOVER_GAP);
  const opensBelow = below >= desiredHeight || (below < desiredHeight && below >= above);
  const available = opensBelow ? below : above;
  const maxHeight = Math.max(minimumHeight, available);
  const top = opensBelow
    ? anchorRect.bottom + POPOVER_GAP
    : Math.max(VIEWPORT_MARGIN, anchorRect.top - POPOVER_GAP - Math.min(desiredHeight, maxHeight));

  return {
    left,
    top,
    width,
    maxHeight,
    placement: opensBelow ? 'bottom' : 'top',
  };
};
